import { render, staticRenderFns } from "./TaxonomyIcon.vue?vue&type=template&id=4a8876d2&scoped=true&"
import script from "./TaxonomyIcon.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8876d2",
  null
  
)

export default component.exports